module.exports = __webpack_public_path__ + "img/Add new section.ea810c4a.svg";